const config = {
    environment: process.env.REACT_APP_ENVIRONMENT,
    name: process.env.REACT_APP_NAME,
    version: process.env.REACT_APP_VERSION,
    sharePointUri: process.env.REACT_APP_SHAREPOINT_URI
};

export default config;
